import { Component, ChangeDetectionStrategy, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);

  readonly toasts$ = this.toastService.toasts$;
  readonly retry = output<string>();

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  onRetry(toast: Toast): void {
    this.retry.emit(toast.id);
    this.toastService.dismiss(toast.id);
  }

  trackById(_index: number, toast: Toast): string {
    return toast.id;
  }

  getIcon(severity: string): string {
    switch (severity) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  }
}
